import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EditingSection } from '@app/features/questionnaire/components/questions/style-tab/section-editors/editing-section';
import { Questionnaire } from '@app/core/models/questionnaire.model';
import { buildRuntimePreviewContext } from '@app/features/questionnaire/components/questions/style-tab/preview/runtime-context.builder';
import { getPagePreviewData } from '@app/features/questionnaire/components/questions/style-tab/preview/preview-style.resolver';

@Component({
  selector: 'app-survey-page-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './survey-page-section.html',
  styleUrl: './survey-page-section.scss',
})
export class SurveyPageSection {
  @Input() questionnaire: Questionnaire | null = null;
  @Input() currentPage = 1;
  @Input() viewMode: 'web' | 'mobile' = 'web';

  get data() {
    if (!this.questionnaire) return null;
    const context = buildRuntimePreviewContext(
      this.questionnaire,
      EditingSection.PAGE_TEMPLATE,
      { currentPage: this.currentPage }
    );
    return getPagePreviewData(context);
  }
}
